import { useTranslations } from 'next-intl'
import { FC, memo } from 'react'

interface TranslateStringProps {
	i18nKey: string
	variables?: Record<string, string>
	context: string
}

/**
 * A custom React hook that provides translations and formatting capabilities using the `next-intl` library.
 *
 * @returns {Function} - A function that takes a `context` parameter and returns the `useTranslations` hook from the `next-intl` library.
 *
 * @example
 * ```
 * import { useTranslations } from 'next-intl'
 * import { FC } from 'react'
 *
 * const MyComponent: FC = () => {
 *   const t = useTranslations('common')
 *   return <div>{t('greeting')}</div>
 * }
 * ```
 */
const TranslateString: FC<TranslateStringProps> = ({
	variables,
	i18nKey,
	context,
}) => {
	const t = useTranslations(context)
	return (
		<span dangerouslySetInnerHTML={{ __html: t(i18nKey, { ...variables }) }} />
	)
}
export default memo(TranslateString)
